import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  LogDTO,
  LogList,
  SummaryLogDTO,
  SummaryLogItem,
} from "../../types/log";
import logApi from "../api/LogApi";
import { LoginLogRequestDTO } from "../../types/adminLog";
import {
  getAdminInfoFromLocalStorage,
  getUserInfoFromLocalStorage,
} from "../../shared/utils/auth";
import dayjs from "dayjs";
import FileSaver from "file-saver";

interface LogState {
  newLogList?: LogList;
  summaryLogList?: SummaryLogItem[];
  contentLogList?: LogList;
}
// # initial state
const initialState: LogState = { newLogList: undefined };
export const trunkNewLogList = createAsyncThunk(
  "log/new/list",
  async (logDTO: LogDTO) => {
    return await logApi.newLogList(logDTO);
  }
);
export const trunkGetSummaryLogList = createAsyncThunk(
  "log/summary",
  async (logDTO: SummaryLogDTO) => {
    return await logApi.getSummaryLogList(logDTO);
  }
);
export const trunkGetLogDetail = createAsyncThunk(
  "log/detail",
  async (req: { logIdList: string[] }) => {
    return await logApi.getLogDetail(req);
  }
);
export const trunkGetDocUserLog = createAsyncThunk(
  "log/conent/detail",
  async (logDTO: LogDTO) => {
    return await logApi.getDocUserLog(logDTO);
  }
);
export const trunkGetDocUserLogExcel = createAsyncThunk(
  "log/doc",
  async (logDTO: LogDTO) => {
    const resp = await logApi.getDocUserLogExcel(logDTO);
    return resp;
  }
);

const logSlice = createSlice({
  name: "log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkNewLogList.fulfilled,
      (state, { payload: newLogList }) => {
        if (newLogList.logId === undefined || newLogList.logId === null) {
          state.newLogList = {
            ...newLogList,
            logResults: newLogList.logResults?.map((item) => {
              return { ...item, children: [] };
            }),
          };
        } else if (
          state.newLogList &&
          newLogList.lastLogId !== "" &&
          newLogList.lastLogId !== newLogList.logId &&
          (state.newLogList.lastLogId ||
            state.newLogList.lastLogId === newLogList.logId)
        ) {
          state.newLogList.logId = newLogList.logId;
          state.newLogList.lastLogId = newLogList.lastLogId;
          state.newLogList.logResults = state.newLogList.logResults.concat(
            newLogList.logResults.map((item) => {
              return { ...item, children: [] };
            })
          );
        }
      }
    );
    builder.addCase(
      trunkGetSummaryLogList.pending,
      (state, { payload: newLogList }) => {
        state.summaryLogList = undefined;
      }
    );
    builder.addCase(
      trunkGetSummaryLogList.fulfilled,
      (state, { payload: newLogList }) => {
        state.summaryLogList = newLogList;
      }
    );
    builder.addCase(
      trunkGetDocUserLog.fulfilled,
      (state, { payload: newLogList }) => {
        state.contentLogList = newLogList;
      }
    );
    builder.addCase(
      trunkGetDocUserLogExcel.fulfilled,
      (state, { payload: res }) => {
        const loginResult = window.location.href.includes("/admin")
          ? getAdminInfoFromLocalStorage()
          : getUserInfoFromLocalStorage();
        if (res.data && res.headers && loginResult) {
          const file = res.data;
          const userId = JSON.parse(loginResult).userInfo.userId;
          const fileName =
            dayjs().format("YYYYMMDD") + "_doc_" + userId + ".xlsx";
          const blob = new Blob([file], { type: "application/download" });

          FileSaver.saveAs(blob, fileName);
        }
      }
    );
  },
});
export const logAction = logSlice.actions;

export default logSlice.reducer;
